const WHERE = 0;
const AND = 1;
const OR = 2;
const AND_CATEGORY = 3;

export default { WHERE, AND, OR, AND_CATEGORY };
